export { PeriscopePage as default } from './ui/index';
